import React, { useEffect, useState } from "react";
import { getProducts } from "../services/api";
import ProductCard from "../components/ProductCard";
import Slider from "../components/Slider";
import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsContext";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const settings = useSettings();

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      setLoading(true);
      const data = await getProducts();
      setProducts(data);
    } catch (err) {
      console.error("Error loading products:", err);
    } finally {
      setLoading(false);
    }
  };

  const pageTitle = settings.site_name || "HandyCraft Bali";
  const pageDesc = settings.about_text || "Koleksi kerajinan tangan Bali terbaik dan otentik.";
  const thumbnailUrl = `${window.location.origin}/assets/branding/thumbnail.png`;

  return (
    <div className="home-page">
      <Helmet>
        <title>{pageTitle} - Kesenian Otentik Bali</title>
        <meta name="description" content={pageDesc} />
        
        {/* Facebook / Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDesc} />
        <meta property="og:image" content={thumbnailUrl} />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDesc} />
        <meta name="twitter:image" content={thumbnailUrl} />
      </Helmet>

      <Slider />

      <div className="container">
        <div className="section-header">
          <p>Koleksi Terbaru</p>
          <h2 className="section-title">Produk Unggulan Kami</h2>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '100px 0' }}>Memuat koleksi...</div>
        ) : (
          <div className="products-grid">
            {products.length > 0 ? (
              products.map((p) => <ProductCard key={p.id} product={p} />)
            ) : (
              <p style={{ gridColumn: '1/-1', textAlign: 'center', color: '#666' }}>
                Belum ada produk yang tersedia.
              </p>
            )}
          </div>
        )}

        <div style={{ textAlign: 'center', margin: '4rem 0' }}>
          <button className="btn btn-outline" onClick={() => window.location.href='/products'}>Lihat Semua Produk</button>
        </div>
      </div>
    </div>
  );
}
